import style_inject_es_default from "../../../../../../node_modules/.pnpm/style-inject@0.3.0/node_modules/style-inject/dist/style-inject.es.js";

//#region src/components/modal/modal.module.css
var css_248z = ".modal-module_root__UqegX {\n    max-width: 600px;\n}\n\n.modal-module_inner__ZRUoo {\n    align-items: center;\n}\n\n.modal-module_title__Zd7pL {\n    font-size: large;\n    color: var(--mantine-color-gray-9);\n    font-weight: 600;\n    text-wrap: pretty;\n}\n\n.modal-module_header__PmCaO {\n    padding: var(--mb-padding, var(--mantine-spacing-sm));\n}\n\n.modal-module_body__km6FQ {\n    color: var(--mantine-color-gray-7);\n}\n\n.modal-module_close__6Qfmi {\n    --cb-size: 2.5rem;\n    --cb-icon-size: 1.5rem;\n    align-self: start;\n}\n";
var modal_module_default = {
	"root": "modal-module_root__UqegX",
	"inner": "modal-module_inner__ZRUoo",
	"title": "modal-module_title__Zd7pL",
	"header": "modal-module_header__PmCaO",
	"body": "modal-module_body__km6FQ",
	"close": "modal-module_close__6Qfmi"
};
style_inject_es_default(css_248z);

//#endregion
export { modal_module_default as default };